export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_fr-db5a32f5.png";